import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import ddt from '@wix/da-ddt';
import Modal from '../Popup/Modal';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { ModalType } from './redux/types';
import LoadableMediaManager from '../MediaPopup/MediaManager';
import { MediaSourceType } from '../MediaPopup/types';
import { LoadablePostPopup, LoadableWriterPopup, LoadableWriterPopupV3, LoadableCommissionEditPopup, LoadablePollEditPopup, LoadableAddToCollectionPopoverModal, LoadablePushNotificationsModal } from './LoadableModals';
import { PostPopupMode } from '../PostPopup.editor_journal_status/types';
import NonContentModals from './NonContentModals';
import LoadableTierPopup from '../Tier/TierPopup';
/** Renders a single one of our many modals based on the contents of the `modal` prop */ const DaModal = ({ modal, children, popModal, currentUser, disableAriaHide })=>{
    const editor_literature = useFlag('editor_literature');
    if (!modal) {
        return null;
    }
    const modalType = modal.type;
    const { options = {} } = modal;
    const { params, wrapInModal, closeBtnClassName } = options;
    let content;
    if (children) {
        try {
            const renderedChildren = children(modalType, popModal, params);
            content = renderedChildren && /*#__PURE__*/ React.createElement(ErrorBoundary, {
                debugComponent: "DaModal"
            }, renderedChildren);
        } catch (e) {
            ddt.error('modals', 'Failed to render custom render function', e);
        }
    }
    if (!content) {
        switch(modalType){
            case ModalType.STATUS_UPDATE:
                return /*#__PURE__*/ React.createElement(LoadablePostPopup, _object_spread_props(_object_spread({
                    onClose: popModal
                }, params), {
                    mode: PostPopupMode.STATUS
                }));
            case ModalType.JOURNAL:
                return /*#__PURE__*/ React.createElement(LoadablePostPopup, _object_spread_props(_object_spread({
                    onClose: popModal
                }, params), {
                    mode: PostPopupMode.JOURNAL
                }));
            case ModalType.LITERATURE:
                return editor_literature ? /*#__PURE__*/ React.createElement(LoadableWriterPopupV3, _object_spread_props(_object_spread({
                    onClose: popModal
                }, params), {
                    type: "LITERATURE"
                })) : /*#__PURE__*/ React.createElement(LoadableWriterPopup, _object_spread_props(_object_spread({
                    onClose: popModal
                }, params), {
                    type: "LITERATURE"
                }));
            case ModalType.CREATE_PREMIUM_FOLDER:
                const reloadPage = (event)=>{
                    popModal();
                    event && event.preventDefault();
                    window.location.reload();
                };
                return /*#__PURE__*/ React.createElement(LoadableMediaManager, {
                    initialMediaSource: MediaSourceType.GALLERY,
                    withMediaSourceSelector: false,
                    withNewGallectionPopupOpen: true,
                    onDone: reloadPage,
                    onClose: reloadPage
                });
            case ModalType.COMMISSION:
                return /*#__PURE__*/ React.createElement(LoadableCommissionEditPopup, _object_spread({
                    onClose: popModal
                }, params));
            case ModalType.POLL_EDIT:
                return /*#__PURE__*/ React.createElement(LoadablePollEditPopup, params);
            case ModalType.TIER_EDIT:
                return /*#__PURE__*/ React.createElement(LoadableTierPopup, _object_spread({
                    requestClose: popModal
                }, params));
            case ModalType.COLLECTION_POPOVER:
                return /*#__PURE__*/ React.createElement(LoadableAddToCollectionPopoverModal, params);
            case ModalType.PUSH_NOTIFICATIONS:
                return /*#__PURE__*/ React.createElement(LoadablePushNotificationsModal, _object_spread({
                    requestClose: popModal
                }, params));
            default:
                content = /*#__PURE__*/ React.createElement(NonContentModals, {
                    modalType,
                    popModal,
                    params,
                    currentUser
                });
        }
    }
    return content && wrapInModal ? /*#__PURE__*/ React.createElement(Modal, {
        onRequestClose: popModal,
        withCloseButton: true,
        isOpen: true,
        width: "auto",
        height: "auto",
        disableAriaHide: disableAriaHide,
        closeBtnClassName: closeBtnClassName
    }, content) : content;
};
DaModal.displayName = 'DaModal';
export default DaModal;

//# sourceMappingURL=DaModal.js.map